module.exports = __webpack_public_path__ + "static/media/avatar-lg.95aa757d.png";